export default "__VITE_ASSET__341a10e6__"